export class SubscriptionContainer<T> {
    private readonly updateHandlers: Set<(t: T) => void>;

    public value: T;

    constructor (initial: T) {
        this.updateHandlers = new Set();
        this.value = initial;
    }

    public setValue = (value: T) => {
        // only set a new value if it has changed
        if (value !== this.value) {
            this.value = value;

            this.updateHandlers.forEach(handler => handler(this.value));
        }
    };

    public onUpdate = (handler: (t: T) => void) => {
        this.updateHandlers.add(handler);

        handler(this.value);

        return () => {
            this.updateHandlers.delete(handler);
        };
    };

}
